<template>
  <div class="pa-application-item-banner" v-if="isLoadedData">
    <div class="left-field">
      <p>{{mutatedTitle}}</p>
    </div>
    <div class="right-field">
      <p class="status-button">{{characterApplication.result | mutateStatusToText}}</p>
    </div>
  </div>
</template>

<script>
import {GetCharacterApplication} from '@/graphql/queries/CharacterApplication.graphql'

export default {
  props : {
    id : {
      default: null
    }
  },

  data(){
    return {
      mutatedTitle : null
    };
  },

  computed : {
    isLoadedData(){
      if(typeof this.characterApplication === 'undefined'){
        return false;
      }else{
        return true;
      }
    }
  },

  watch : {
    characterApplication(data){
      if(data.park !== null){
        this.mutatedTitle = '【ひろば開設審査】'+this.$options.filters.jpSmaryTruncate(data.title, 4);
      }
    }
  },

  apollo : {
    characterApplication : {
      query : GetCharacterApplication,

      variables(){
        return {
          id  : this.id,
        };
      },

      skip(){
        if(this.id === null){
          return true;
        }else{
          return false;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  filters : {
    mutateStatusToText(value){
      const statusToText = {
        'pending'   : '審査中',
        'approved'  : '許可済',
        'rejected'  : '不許可'
      };

      return statusToText[value];
    }
  }
}
</script>

<style lang="scss">
.pa-application-item-banner{
  display: flex;
  border-bottom:1px solid #aad4c5;

  div.left-field{
    width:70%;
  }

  div.right-field{
    width:30%;

    p.status-button{
      margin-left:10px;
      background-color:#8FC1AF;
      color: #547166;
      border-radius: 6px;
      padding:2px 6px;
      text-align: center;
    }
  }
}

.pa-message-set{
  &-default{
    .pa-application-item-banner{
      border-bottom:1px solid #aad4c5;

      div.right-field{
        p.status-button{
          background-color:#8FC1AF;
          color: #547166;
        }
      }
    }
  }

  &-lilica{
    .pa-application-item-banner{
      border-bottom:1px solid #d4aacb;

      div.right-field{
        p.status-button{
          background-color:#c18fbd;
          color: #6c5471;
        }
      }
    }
  }
}
</style>